import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';

import {CModuleRepository} from '../repositories/cmodule.repository';
import { CModule } from '../model/model';

@Injectable()
export class CModuleService {

  constructor(private cmoduleRepository: CModuleRepository) { }

  public getCModules(type:string): Observable<Array<CModule>> {
    return this.cmoduleRepository.getCModules(type);
  }

  public getCModule(cmodule: CModule): Observable<CModule> {
    return this.cmoduleRepository.getCModule(cmodule._id);
  }

}
